export const REALM_PROFILE_DESKTOP_COVER_DIMENSIONS = {
  ratio: 1616 / 583,
  width: 1616,
  height: 583
};

export const REALM_PROFILE_APP_COVER_DIMENSIONS = {
  ratio: 960 / 922,
  width: 960,
  height: 922
};

export const REALM_PROFILE_AVATAR_DIMENSIONS = {
  ratio: 1,
  width: 600,
  height: 600
};
